import { SheetSurfaceInternalContext } from "@ui/components/SheetSurface/SheetSurfaceContext";
import { Sheet } from "@ui/primitives/Sheet";
import { type ReactNode, use } from "react";

export interface SurfaceTitleProps {
  children: ReactNode;
  className?: string;
}

/**
 * The surface's accessible name. Renders a Silk `Sheet.Title` (wired to
 * `aria-labelledby` automatically) inside a Dialog/Page root, and a plain
 * heading when the parts render standalone (content stories, previews) —
 * `Sheet.Title` throws outside a Sheet root. Usually supplied by
 * `Dialog.Header`; custom-chrome dialogs render it directly (sr-only).
 */
export function SurfaceTitle({ children, className }: SurfaceTitleProps) {
  const internal = use(SheetSurfaceInternalContext);
  if (!internal) {
    return <h2 className={className}>{children}</h2>;
  }
  return <Sheet.Title className={className}>{children}</Sheet.Title>;
}
